import { S as SocialLoginResponseStatus } from '../../chuck/SocialLoginResponseStatus-BP1cpX8W.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var FacebookSdkLogin = /*#__PURE__*/ _async_to_generator(function(config) {
    return _ts_generator(this, function(_state) {
        try {
            if (!FB) {
                return [
                    2,
                    {
                        status: SocialLoginResponseStatus.LoadError
                    }
                ];
            }
            return [
                2,
                new Promise(function(resolve) {
                    FB.login(function(response) {
                        if (response.status === 'connected' && response.authResponse) {
                            resolve({
                                code: response.authResponse.accessToken,
                                status: SocialLoginResponseStatus.Success
                            });
                        } else if (response.status === 'unknown') {
                            resolve({
                                status: SocialLoginResponseStatus.Unknown
                            });
                        } else {
                            resolve({
                                status: SocialLoginResponseStatus.Error
                            });
                        }
                    }, {
                        scope: config.scope
                    });
                })
            ];
        } catch (error) {
            return [
                2,
                {
                    status: SocialLoginResponseStatus.Error,
                    error: "" + error
                }
            ];
        }
        return [
            2
        ];
    });
});

function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var fbSDKVersion = 'v9.0';
var checkFBSdkLoaded = function() {
    return (typeof FB === "undefined" ? "undefined" : _type_of(FB)) === 'object' && !!FB.init;
};
var waitForFacebookSDKLoad = function(maxRetries) {
    if (maxRetries === void 0) maxRetries = 30;
    var retries = 0;
    return new Promise(function(resolve, reject) {
        var waitForFacebookSDKIntervalId = setInterval(function() {
            if (retries >= maxRetries) {
                window.clearInterval(waitForFacebookSDKIntervalId);
                reject(new Error("FB SDK load reached maximum retries, " + maxRetries));
            }
            retries += 1;
            if (checkFBSdkLoaded()) {
                window.clearInterval(waitForFacebookSDKIntervalId);
                resolve(true);
            }
        }, 100);
    });
};
var FacebookSdkLoader = function(config) {
    var culture = config.culture, appId = config.appId;
    if (checkFBSdkLoaded()) {
        return Promise.resolve(true);
    }
    return new Promise(function(resolve, reject) {
        if (document.getElementById('facebook-jssdk')) {
            resolve(true);
        }
        var sdkScript = document.createElement('script');
        sdkScript.id = 'facebook-jssdk';
        sdkScript.src = "https://connect.facebook.net/" + culture + "/sdk.js";
        sdkScript.async = true;
        sdkScript.defer = true;
        sdkScript.crossOrigin = 'anonymous';
        sdkScript.addEventListener('load', function() {
            waitForFacebookSDKLoad().then(function() {
                FB.init({
                    appId: appId,
                    version: fbSDKVersion,
                    xfbml: false
                });
                resolve(true);
            }).catch(reject);
        });
        sdkScript.addEventListener('error', function() {
            return reject(new Error('FB SDK Error loading script.'));
        });
        sdkScript.addEventListener('abort', function() {
            return reject(new Error('FB SDK Script loading aborted.'));
        });
        document.body.appendChild(sdkScript);
    });
};

export { FacebookSdkLoader, FacebookSdkLogin };
